import './previewlinkblock.less'

import {m, Picture, View} from '@codeurs/front'
import {FunctionComponent} from 'react'
import {ImageType, LinkType} from 'types'
import {style} from 'util/style'
import {LinkArrow} from 'views/partials/linkarrow'
import {Theme} from 'views/theme'
import {Block} from './blocks'

export type PreviewLinkType = {
	image: ImageType
	title: string
	text: string
	link: LinkType
}

const styles = style('previewlinkblock')

export const PreviewLinkBlock: FunctionComponent<PreviewLinkType> = ({
	image,
	title,
	text,
	link
}) => {
	return (
		<Block class={styles}>
			{image && (
				<div class={styles('col-image')}>
					<div class={styles('col-image-container')}>
						<Picture className={styles('image').toString()} {...image} />
					</div>
				</div>
			)}
			<div class={styles('col-text')}>
				<Theme.H2 class={styles('title')}>{title}</Theme.H2>
				<Theme.Wysiwyg class={styles('text')}>{text}</Theme.Wysiwyg>
				{link && (
					<Theme.Button mod={'rounded'} to={link.url}>
						<span>{link.description || link.title}</span>
						<LinkArrow />
					</Theme.Button>
				)}
			</div>
		</Block>
	)
}
